import DoneIcon from '@eduzz/houston-icons/Done';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import { MuiThemeProvider } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import { MyTablePagination } from 'components/MyTable/';
import Spin from 'components/Spin';
import { theme } from 'components/Theme';
import moment from 'moment';
import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { listProducts } from 'store/Orbita/Product/actions';
import { listQuestions, listChatQuestions } from 'store/Orbita/Questions/actions';

import Chat from './components/Chat';
import styles from './styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  classes: any;
  listProducts: any;
  list: any;
  pagination: any;
  listChatQuestions: any;
}

interface IStates {
  filterActive: boolean;
  focusedInput: any;
  filters: any;
  isFetching: boolean;
  questionActive: number;
}

class Questions extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      filterActive: true,

      filters: {
        start: null,
        end: null,
        content: 'not-selected',
        client: '',
      },

      focusedInput: null,

      isFetching: true,

      questionActive: 0,
    };
  }

  handleClickButtonFilter = () => {
    this.setState({
      filterActive: !this.state.filterActive,
    });
  };

  handleChangeField = (name: string) => (event: any) => {
    let newState = this.state;
    newState.filters[name] = event.target.value;

    this.setState(newState);
  };

  onChangeDate = (startDate: any, endDate: any) => {
    let newState = this.state.filters;
    newState.start = startDate;
    newState.end = endDate;

    this.setState({ filters: newState });
  };

  onChangePaginationNumber = (page: any) => {
    this.onShowSizeChange(page, this.props.pagination.per_page);
  };

  onShowSizeChange = (current: any, size: any) => {
    this.callMoreData({ per_page: size, current_page: current });
  };

  handleClickFilter = () => {
    this.setState({ questionActive: 0 });
    this.callMoreData({ per_page: this.props.pagination.per_page, current_page: 1 }, this.state.filters);
  };

  handleClickQuestion = async (chat_id: number) => {
    try {
      this.setState({ questionActive: chat_id === this.state.questionActive ? 0 : chat_id });
      await this.props.dispatch(listChatQuestions(chat_id));
    } catch (error) {
      toast.error(error);
    }
  };

  callMoreData = async (pagination: any, filters?: any) => {
    this.setState({ isFetching: true, questionActive: 0 });
    await this.props.dispatch(listQuestions(pagination, filters));
    this.setState({ isFetching: false });
  };

  componentDidMount() {
    this.callMoreData({ current_page: 1, per_page: 10 });

    (async () => {
      try {
        await this.props.dispatch(listProducts(true));
      } catch (error) {
        toast.error(error);
      }
    })();
  }

  render() {
    const { classes, listProducts, list, listChatQuestions } = this.props;
    const { filterActive, focusedInput, filters, isFetching, questionActive } = this.state;

    return (
      <Fade in={true} timeout={500}>
        <MuiThemeProvider theme={theme}>
          <div className='my-title'>
            <h1>Perguntas</h1>
            <p>Responda suas perguntas da vitrine.</p>
          </div>

          <div className='m16'></div>

          <div className={classes.filter}>
            <Button
              id='open-filter-button'
              variant='text'
              onClick={this.handleClickButtonFilter}
              className={`${classes.buttonFilter} ${filterActive ? '--active' : ''}`}
            >
              <Icon>filter_list</Icon> Filtrar
            </Button>
          </div>

          <div className={`${classes.containerFilter} ${filterActive ? '--active' : ''}`}>
            <div className={classes.containerContent}>
              <Grid container spacing={2} alignItems='flex-end'>
                <Grid item xs={12} md={3} className={classes.controlDatePicker}>
                  <label className={classes.labelPeriod}>Período</label>
                  <DateRangePicker
                    startDate={filters.start}
                    startDateId='start_date'
                    endDate={filters.end}
                    endDateId='end_date'
                    onDatesChange={({ startDate, endDate }: any) => this.onChangeDate(startDate, endDate)}
                    focusedInput={focusedInput}
                    onFocusChange={(focusedInput: any) => this.setState({ focusedInput })}
                    displayFormat={'DD/MM/YYYY'}
                    small
                    startDatePlaceholderText={'Data inicial'}
                    endDatePlaceholderText={'Data final'}
                    isOutsideRange={() => false}
                    minimumNights={0}
                    block
                    orientation={'horizontal'}
                    numberOfMonths={window.innerWidth <= 760 ? 1 : 2}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    id='select-product'
                    label='Produto'
                    fullWidth
                    select
                    value={filters.content}
                    onChange={this.handleChangeField('content')}
                  >
                    <MenuItem value='not-selected' selected>
                      {listProducts && listProducts.isFetching ? 'Carregando...' : 'Selecione um conteúdo'}
                    </MenuItem>

                    {!listProducts.isFetching &&
                      listProducts.length > 0 &&
                      listProducts.map((product: any, index: any) => {
                        return (
                          <MenuItem key={index} value={product.id}>
                            {product.title}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id='client-affiliate'
                    label='Cliente/Afiliado'
                    fullWidth
                    value={filters.client}
                    onChange={this.handleChangeField('client')}
                    placeholder='Nome/E-mail/Código'
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <Button
                    id='filter-button'
                    fullWidth
                    className={classes.buttonSearch}
                    color='secondary'
                    variant='contained'
                    onClick={this.handleClickFilter}
                    disabled={isFetching}
                  >
                    Filtrar
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>

          <div className='m24'></div>

          <div className={classes.listQuestions}>
            {isFetching && <Spin />}

            {!isFetching &&
              list?.map((item: any) => {
                return (
                  <div className={classes.questions} key={'question-' + item.chat_id}>
                    <ExpansionPanel classes={{ root: classes.questionsContainer }} expanded={questionActive === item.chat_id}>
                      <ExpansionPanelSummary
                        onClick={() => this.handleClickQuestion(item.chat_id)}
                        classes={{ content: classes.questionsContent }}
                        expandIcon={<Icon>expand_more</Icon>}
                      >
                        <div className={classes.questionsText}>
                          <p className={classes.questionsTitle}>{item.question}</p>
                          <span>
                            {item.customer_name} em {moment(item.asked_at).format('L')} sobre {item.product_title}
                          </span>
                        </div>
                        {item.answered && (
                          <Tooltip title='Já respondido' placement='top'>
                            <DoneIcon size={24} className={classes.doneIcon} />
                          </Tooltip>
                        )}
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        {listChatQuestions && <Spin />}

                        {!listChatQuestions && <Chat active={questionActive} />}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </div>
                );
              })}

            {!isFetching && (
              <MyTablePagination
                onPageChange={(e: any, page: any) => this.onChangePaginationNumber(page + 1)}
                rowsPerPage={this.props.pagination ? this.props.pagination.per_page : 0}
                count={this.props.pagination ? this.props.pagination.total_items : 0}
                page={this.props.pagination ? this.props.pagination.current_page - 1 : 0}
                labelDisplayedRows={({ from, to, count }: any) => `${from}-${to} de ${count}`}
                labelRowsPerPage='Itens por página:'
                onChangeRowsPerPage={(e: any) => this.onShowSizeChange(1, e.target.value)}
                rowsPerPageOptions={[10, 20, 30, 40]}
              />
            )}
          </div>
        </MuiThemeProvider>
      </Fade>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    listProducts: state.orbita.Product.list,
    list: state.orbita.Questions.list.data,
    pagination: state.orbita.Questions.list.pagination,
    listChatQuestions: state.orbita.Questions.listChatQuestions.isFetching,
  };
}

export default connect(mapStateToProps)(styles(Questions));
